<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Error</p>
      <button class="delete" aria-label="close" @click="$emit('close')"></button>
    </header>
    <section v-if="raw" class="modal-card-body error_content">
      <textarea rows="20" cols="40" style="border:none;" readonly>
        {{ parseLineFeeds(error) }}
      </textarea>
    </section>
    <section v-else v-html="formatError(error)" class="modal-card-body error_content"></section>
    <footer class="modal-card-foot">
      <button class="button flex-pulled-right" @click="$emit('close')">Close</button>
    </footer>
  </div>
</template>

<script>
import { parseLineFeeds } from '../utils'

export default {
  name: 'ErrorModal',
  props: {
    error: null,
    raw: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    buildErrorListFromObject: function (object) {
      return Object.keys(object).map(attr => {
        if (typeof object[attr] === 'string') {
          return `<div><p>${attr}: ${object[attr]}</p></div>`
        } else if (object[attr] instanceof Array) {
          return `<ul><p>${attr}:</p>${object[attr].map((error, index) => {
            if (typeof error === 'string') {
              return `<li>  &bullet; ${error}</li>`
            } else {
              return `<ul><p>Item ${index + 1}:</p>${this.buildErrorListFromObject(error)}</ul>`
            }
          }).join('<br>')}</ul>`
        } else {
          return `<ul><li>${attr}: ${this.buildErrorListFromObject(object[attr])}</li></ul>`
        }
      }).join('<br>')
    },
    buildErrorListFromArray: function (object) {
      return object.map(obj => this.buildErrorListFromObject(obj)).join('<br>')
    },
    formatError: function (error) {
      console.error(error)
      let content = error
      if (error.response) {
        content = error.response.data
        if (error.response.status === 403) {
          content = 'Your account does not have the correct permissions to use this application'
        }
      }

      // build a human readable representation of the error dict that DRF returns
      if (content instanceof Array) {
        content = this.buildErrorListFromArray(content)
      } else if (typeof content === 'object') {
        content = this.buildErrorListFromObject(content)
      }

      return content
    },
    parseLineFeeds
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label { display: inline-block; width: 150px; text-align: left; }
.modal-card-head { background-color: #d1322e; }
textarea { width: 100% }
</style>
